export default __webpack_public_path__ + "static/tag-do-4-light-7762e8067505a0b5b7bf361f16bb21707ac97ba12d4767bf222777122424df91.png";